import React, { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import Spinner from "../../components/Spinner";
import ParamGraph from "../../components/ParamGraph";
import {
  loadTickets,
  loadTicketsClosedAll,
  loadTicketsOpenAll,
} from "../../redux/tasks/ticketsT";

const DashboardAdmin = ({
  loading,
  tickets,
  openTickets,
  closedTickets,
  loadTickets,
  loadTicketsOpenAll,
  loadTicketsClosedAll,
  role,
}) => {
  useEffect(() => {
    loadTickets();
    loadTicketsOpenAll();
    loadTicketsClosedAll();
  }, [loadTickets, loadTicketsOpenAll, loadTicketsClosedAll]);

  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className="flex flex-col h-screen">
        <TopBar />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <main className="flex-1 p-4 overflow-y-auto">
            {tickets?.length > 0 ? (
              <>
                <h1 className="px-6 font-bold text-2xl">All Tickets</h1>
                <ParamGraph tickets={tickets} role={role} filters={true} />
              </>
            ) : (
              <h1 className="flex justify-center items-center font-bold text-3xl my-20">
                No Tickets available
              </h1>
            )}
            {openTickets?.length > 0 ? (
              <>
                <h1 className="px-6 font-bold text-2xl">Open Tickets</h1>
                <ParamGraph tickets={openTickets} role={role} filters={false} />
              </>
            ) : (
              <h1 className="flex justify-center items-center font-bold text-3xl my-20">
                No Open Tickets available
              </h1>
            )}
            {closedTickets?.length > 0 ? (
              <>
                <h1 className="px-6 font-bold text-2xl">Closed Tickets</h1>
                <ParamGraph
                  tickets={closedTickets}
                  role={role}
                  filters={false}
                />
              </>
            ) : (
              <h1 className="flex justify-center items-center font-bold text-3xl my-20">
                No Closed Tickets available
              </h1>
            )}
          </main>
        </div>
      </div>
    </>
  );
};

DashboardAdmin.propTypes = {
  loading: PropTypes.bool.isRequired,
  tickets: PropTypes.array,
  openTickets: PropTypes.array,
  closedTickets: PropTypes.array,
  role: PropTypes.string,
  loadTickets: PropTypes.func.isRequired,
  loadTicketsOpenAll: PropTypes.func.isRequired,
  loadTicketsClosedAll: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.tickets.loading,
  tickets: state.tickets.tickets,
  openTickets: state.tickets.openTickets,
  closedTickets: state.tickets.closedTickets,
  role: state.auth.user.role,
});

export default connect(mapStateToProps, {
  loadTickets,
  loadTicketsOpenAll,
  loadTicketsClosedAll,
})(DashboardAdmin);
